import { create } from 'zustand';

type UseCountriesReferentialState = {
  countriesReferential: Record<string, string>;
};

export const useCountriesReferentialState = create<UseCountriesReferentialState>(() => ({
  countriesReferential: {},
}));
